customElements.get("ebt-modal") || customElements.define("ebt-modal", class extends ModalDialog {
    constructor() {
        super(),
        this.querySelectorAll('[id^="ModalConfirm-"]').forEach(confirmButton => confirmButton.addEventListener("click", this.confirm.bind(this)))
    }
    confirm() {
        this.openedBy.checked = !0,
        this.openedBy.dispatchEvent(new Event("change")),
        this.hide()
    }
}
);
